module.exports = __webpack_public_path__ + "fonts/Golos-Text_Bold.bf17664.ttf";